import happyIcon from '../../static/icons/self-observation/happy.png';
import neutralIcon from '../../static/icons/self-observation/neutral.png';
import sadIcon from '../../static/icons/self-observation/sad.png';
import veryHappyIcon from '../../static/icons/self-observation/very-happy.png';
import verySadIcon from '../../static/icons/self-observation/very-sad.png';

type Properties = {
    value?: 1 | 2 | 3 | 4 | 5; // 1 = very bad, 5 = very happy
    setValue: (value: 1 | 2 | 3 | 4 | 5 | undefined) => void;
};

const imagePaths = ['very-sad.png', 'sad.png', 'neutral.png', 'happy.png', 'very-happy.png'];
const moodIcons: Record<string, string> = {
    'happy.png': happyIcon,
    'neutral.png': neutralIcon,
    'sad.png': sadIcon,
    'very-happy.png': veryHappyIcon,
    'very-sad.png': verySadIcon
};

const SelfObservationMoodInput = (props: Properties) => {
    const onImageClick = (value: 1 | 2 | 3 | 4 | 5) => {
        if (value === props.value) {
            props.setValue(undefined);  // unselect value
        } else {
            props.setValue(value);
        }
    };

    const images = imagePaths.map((path: string, index: number) => {
        let style = {};
        if (index + 1 !== props.value) {
            style = { filter: 'grayscale(1)' };
        }

        return (
        <span 
            key={index}
            className="selfobservation-mood-input-column"
            onClick={() => onImageClick((index + 1) as any)}
        >
            <img
                src={moodIcons[path]}
                style={style}
            />
        </span>);
    });

    return (
        <div className="selfobservation-mood-input">
            {images}
        </div>
    );
};
export default SelfObservationMoodInput;